module.exports = __webpack_public_path__ + "img/configurazione invio mail jobmule.fed17afc.png";